import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import GlobalStyles from './styles/GlobalStyles';
import App from './App';

// Handler global para promises rejeitadas não tratadas
window.addEventListener('unhandledrejection', (event) => {
  const timestamp = new Date().toISOString();
  const errorDetails = {
    timestamp,
    reason: event.reason,
    promise: event.promise,
    error: event.reason?.message || event.reason,
    stack: event.reason?.stack,
    name: event.reason?.name,
    stringified: String(event.reason),
    response: event.reason?.response ? {
      status: event.reason.response.status,
      statusText: event.reason.response.statusText,
      data: event.reason.response.data,
      headers: event.reason.response.headers
    } : null,
    config: event.reason?.config ? {
      url: event.reason.config.url,
      method: event.reason.config.method,
      baseURL: event.reason.config.baseURL,
      timeout: event.reason.config.timeout,
      data: event.reason.config.data
    } : null
  };
  
  console.error(`[${timestamp}] [Global] ❌❌❌ UNHANDLED PROMISE REJECTION:`, errorDetails);
  console.error(`[${timestamp}] [Global] Rejection Reason Type:`, typeof event.reason);
  console.error(`[${timestamp}] [Global] Rejection Reason:`, event.reason);
  
  // Logar mais detalhes se for um erro
  if (event.reason instanceof Error) {
    console.error(`[${timestamp}] [Global] Error Details:`, {
      message: event.reason.message,
      name: event.reason.name,
      stack: event.reason.stack,
      cause: event.reason.cause
    });
  }
  
  // Se for um erro de axios, logar detalhes adicionais
  if (event.reason?.isAxiosError) {
    console.error(`[${timestamp}] [Global] Axios Error Details:`, {
      message: event.reason.message,
      code: event.reason.code,
      config: {
        url: event.reason.config?.url,
        method: event.reason.config?.method,
        baseURL: event.reason.config?.baseURL,
        timeout: event.reason.config?.timeout
      },
      response: event.reason.response ? {
        status: event.reason.response.status,
        statusText: event.reason.response.statusText,
        data: event.reason.response.data
      } : null
    });
  }
  
  // Prevenir o erro de aparecer no console do navegador (opcional)
  // event.preventDefault();
});

// Handler global para erros não capturados
window.addEventListener('error', (event) => {
  console.error('[Global] Unhandled Error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error
  });
});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <AuthProvider>
        <GlobalStyles />
        <App />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#f8fafc',
              border: '1px solid #334155',
            },
            success: {
              iconTheme: {
                primary: '#22c55e',
                secondary: '#f8fafc',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#f8fafc',
              },
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
